<script lang="ts">
	import { highlightText } from '@repo/commons/utils'

	interface Props {
		text: string
		pattern?: string
		caseSensitive?: boolean
		highlightClass?: string
		onHighlightMatch?: (match: string, isExactMatch: boolean) => void
		class?: string
	}

	let {
		text,
		pattern = '',
		caseSensitive = false,
		highlightClass = 'search-highlight',
		onHighlightMatch,
		class: className = ''
	}: Props = $props()

	let highlightedHtml = $state('')
	let lastProcessedPattern = $state('')
	let hasTriggeredForCurrentPattern = $state(false)

	const highlightOptions = $derived({
		onMatch: (match: string, isExactMatch: boolean) => {
			if (onHighlightMatch && !hasTriggeredForCurrentPattern && pattern) {
				hasTriggeredForCurrentPattern = true

				queueMicrotask(() => {
					onHighlightMatch(match, isExactMatch)
				})
			}
		},
		caseSensitive,
		highlightClass
	})

	$effect(() => {
		// Reset the flag when the pattern actually changes
		if (pattern !== lastProcessedPattern) {
			hasTriggeredForCurrentPattern = false
			lastProcessedPattern = pattern
		}

		// Only highlight if we have a pattern
		if (pattern) {
			highlightedHtml = highlightText(text, pattern, highlightOptions)
		} else {
			highlightedHtml = text
		}
	})
</script>

<span class={className}>
	{@html highlightedHtml}
</span>

<style>
	:global(.search-highlight) {
		@apply bg-[#FFE019]/30;
	}
</style>
